<div class="footer-with-environment-informations">
  <span class="company"></span>

  <span class="project-info">
    <!-- CLICKABLE VERSION -->
    <span
      class="version"
      role="button"
      tabindex="0"
      [attr.aria-expanded]="showAll"
      (click)="toggleVersions($event)"
      (keydown.enter)="toggleVersions($event)"
      (keydown.space)="toggleVersions($event)"
      title="Show module versions"
    >
      <i class="fa-solid fa-laptop-code"></i>{{ version }}
    </span>

    <!-- SLIDE-DOWN PANEL -->
    <div class="versions-panel" *ngIf="showAll" @slide>
      <div class="panel-header">
        <button pButton pRipple icon="fa-solid fa-clipboard"
                [cdkCopyToClipboard]="markdownTable"
                (cdkCopyToClipboardCopied)="onCopied($event)"
                class="p-button-text p-button-sm copy-button" [pTooltip]="'Copy as Markdown table'">
          <span>&nbsp;&nbsp;Module versions</span>
        </button>
        <button pButton pRipple icon="pi pi-times" (click)="showAll=false" aria-label="Close"
                class="p-button-text p-button-sm close-button">
        </button>
      </div>
      <ul class="versions-list">
        <li *ngFor="let item of allVersions; trackBy: trackByKey">
          <code class="mod">{{ item.key }}</code>
          <span class="sep">—</span>
          <span class="val">{{ item.value }}</span>
        </li>
      </ul>
    </div>

    <span class="environment">
      <i class="fa-solid fa-server"></i>{{ environmentName }}
    </span>
  </span>
  <!-- tiny copied toast -->
  <div class="copied-toast" *ngIf="justCopied">Copied ✓</div>
</div>
